const PREFIX = "idem:";

/**
 * Жизненный цикл `Idempotency-Key`.
 *
 * Ключ рождается на СТАРТЕ ДЕЙСТВИЯ, а не на попытке отправки. Если
 * генерировать его внутри обработчика клика или внутри `mutationFn`, то ретрай
 * после таймаута уйдёт с новым ключом — и бэкенд честно проведёт вторую
 * покупку. Один и тот же ключ, наоборот, вернёт сохранённый ответ первой.
 *
 * Ключ живёт в `sessionStorage`, чтобы пережить перезагрузку посреди мастера
 * и не утечь в соседнюю вкладку.
 */
export function actionKey(actionId: string): string {
  const storageKey = PREFIX + actionId;
  try {
    const existing = sessionStorage.getItem(storageKey);
    if (existing) return existing;
    const created = crypto.randomUUID();
    sessionStorage.setItem(storageKey, created);
    return created;
  } catch {
    // Storage недоступен — ключ всё равно нужен. Идемпотентность в этом
    // случае держится только в пределах одной попытки.
    return crypto.randomUUID();
  }
}

/**
 * Сбросить ключ. Вызывается на успехе и при изменении тела действия: тот же
 * ключ с другим телом бэкенд отвергает с 409 и `details.key`.
 */
export function resetActionKey(actionId: string): void {
  try {
    sessionStorage.removeItem(PREFIX + actionId);
  } catch {
    /* см. выше */
  }
}
